import { useEffect, useState } from 'react'

const SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

export const scrambleText = (text: string, revealedCount: number) =>
  text
    .split('')
    .map((char, i) =>
      i < revealedCount || char === ' '
        ? char
        : SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)],
    )
    .join('')

// Decrypt-style reveal on mount: characters settle left-to-right while the
// rest keep scrambling. Mount it when the value is revealed; unmount to hide.
export const DecryptedText = ({ text, speed = 15 }: { text: string; speed?: number }) => {
  const [display, setDisplay] = useState(() => scrambleText(text, 0))
  const [prevText, setPrevText] = useState(text)
  // Render-phase reset: a new text prop must never paint the previous (fully
  // revealed) value, even for one frame — re-scramble before this render commits.
  if (prevText !== text) {
    setPrevText(text)
    setDisplay(scrambleText(text, 0))
  }

  useEffect(() => {
    let revealed = 0
    const interval = setInterval(() => {
      revealed += 1
      setDisplay(scrambleText(text, revealed))
      if (revealed >= text.length) clearInterval(interval)
    }, speed)
    return () => clearInterval(interval)
  }, [text, speed])

  return (
    <>
      <span className="sr-only">{text}</span>
      <span aria-hidden="true">{display}</span>
    </>
  )
}
